import type { NsureClientCaseStateCaseStatus } from "Infrastructure/ApiZfp/Schema";
import { createContext } from "react";

type InvestmentCaseContextType = {
  readonly lockedCaseStatus: NsureClientCaseStateCaseStatus | null;
  readonly isInvestmentCaseLocked: boolean;
};

export const InvestmentCaseContext = createContext<InvestmentCaseContextType>({
  lockedCaseStatus: null,
  isInvestmentCaseLocked: false,
});
